import { RootState } from '@next/core-lib/app';

export interface BrandingState extends RootState {
  isAgravisUser: boolean;
}

export class BrandingLogoSrc {
  public static readonly PoultryNextLogo = '/assets/images/poultry-next-logo.svg';
  public static readonly AgravisLogo = '/assets/images/agravis-logo.svg';
  public static readonly AgravisFavicon32 = '/assets/images/agravis-favicon-32x32.png';
}
